import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const PencilIcon = () => {
  const {themeName} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M0.998047 14.998H3.91431L12.5153 6.39702L9.59908 3.48076L0.998047 12.0818V14.998ZM2.55339 12.7273L9.59908 5.68156L10.3145 6.39702L3.26884 13.4427H2.55339V12.7273Z"
        fill={themeName!="light"?"white":"black"}
      />
      <path
        d="M12.9508 1.22552C12.6475 0.922224 12.1576 0.922224 11.8543 1.22552L10.4312 2.64865L13.3474 5.56491L14.7706 4.14178C15.0739 3.83849 15.0739 3.34855 14.7706 3.04526L12.9508 1.22552Z"
        fill={themeName!="light"?"white":"black"}
      />
    </svg>
  );
};

export default PencilIcon;
